import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../data/store';
import Modal from './common/Modal';
import { styled } from 'styled-components';
import Button from './common/buttons/Button';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { updateSelf } from '../data/thunks/userThunk';

export default function SubscriptionModal() {
	const {
		company: { subscription },
	} = useSelector((state: RootState) => state.companyState);
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	const [acceptedTermsAndConditions, setAcceptedTermsAndConditions] =
		useState(false);

	const isTrialExpired = subscription
		? subscription.status === 'trialing' &&
		  dayjs(subscription.trialEnd).isBefore(dayjs())
		: false;

	const open =
		(subscription?.status === 'canceled' || isTrialExpired) &&
		location.pathname !== '/terms-and-conditions' &&
		location.pathname !== '/company' &&
		location.pathname !== '/signup-company' &&
		location.pathname !== '/login';

	const handleContinue = () => {
		dispatch(
			updateSelf({
				acceptedTermsAndConditions: true,
				acceptedTermsAndConditionsDate: new Date(),
			})
		);
		navigate('/company', { state: { openSubscriptionModal: true } });
	};

	return (
		<Modal open={open} handleClose={() => {}}>
			<FormContainer>
				{subscription?.status === 'canceled' && (
					<SubscriptionCanceled />
				)}
				{isTrialExpired && (
					<TrialEnded
						freeTrialEnd={subscription?.trialEnd || new Date()}
					/>
				)}
				<Button
					onClick={handleContinue}
					variant="contained"
					color="primary"
					disabled={
						subscription?.status === 'incomplete' &&
						!acceptedTermsAndConditions
					}
				>
					Continue to payment
				</Button>
			</FormContainer>
		</Modal>
	);
}

const SubscriptionCanceled = () => {
	return (
		<MessageContainer>
			<Typography>Your subscription has been canceled.</Typography>
		</MessageContainer>
	);
};

const TrialEnded = (props: { freeTrialEnd: Date }) => {
	return (
		<MessageContainer>
			<h2>Free Trial Expired</h2>
			<p>
				Your free trial period has ended. To continue using our
				services, please upgrade to a paid subscription.
			</p>
			<p>
				Your trial ended on:{' '}
				{dayjs(props.freeTrialEnd).format('MMMM D, YYYY')}
			</p>
		</MessageContainer>
	);
};

const MessageContainer = styled.div`
	margin-bottom: 20px;
	text-align: center;

	h2 {
		color: ${({ theme }) => theme.palette.error.main};
		margin-bottom: 16px;
	}

	p {
		margin-bottom: 8px;
	}
`;

const FormContainer = styled.div`
	max-width: 600px;
`;
